"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_tag_1 = require("graphql-tag");
exports.ratingDayQuery = graphql_tag_1.default("query ratingDay($id: String!) {\n  ratingDay(id: $id) {\n    userPosition\n    users {\n      userId\n      bestAverageSpeed\n      bestTime\n      costumeColor\n      name\n      penaltyTime\n      profileImageUrl\n    }\n    usersCount\n  }\n}");
